import React from 'react';
import { ResponsiveContainer } from 'recharts';

export const ChartLoading = () => {
  return (
    <div className='h-[300px]'>
      <div className='h-2.5 bg-stone-200 animate-pulse rounded-full w-32 mb-2.5'></div>
      <div className='w-48 h-2 mb-10 bg-stone-200 animate-pulse rounded-full'></div>
      <div className='flex items-baseline mt-4 space-x-6'>
        <div className='w-full bg-stone-200 animate-pulse rounded-t-lg h-48'></div>
        <div className='w-full h-52 bg-stone-200 animate-pulse rounded-t-lg'></div>
        <div className='w-full bg-stone-200 animate-pulse rounded-t-lg h-48'></div>
        <div className='w-full h-64 bg-stone-200 animate-pulse rounded-t-lg'></div>
        <div className='w-full bg-stone-200 animate-pulse rounded-t-lg h-52'></div>
        <div className='w-full bg-stone-200 animate-pulse rounded-t-lg h-52'></div>
        <div className='w-full bg-stone-200 animate-pulse rounded-t-lg h-52'></div>
      </div>
    </div>
  );
};

export const ChartContainer = ({
  children,
  height = '300px',
}: {
  children: React.ReactNode;
  height?: string;
}) => {
  return (
    <div className={`mt-10`} style={{ height }}>
      <ResponsiveContainer width='100%' height='100%'>
        {children}
      </ResponsiveContainer>
    </div>
  );
};
